import { render, staticRenderFns } from "./HistoricoPropostas.vue?vue&type=template&id=55860f78&"
import script from "./HistoricoPropostas.vue?vue&type=script&lang=js&"
export * from "./HistoricoPropostas.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoPropostas.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports